import { Star } from "lucide-react";
import { motion } from "framer-motion";
import { easeOutStrong } from "@/lib/motion";

export default function TestimonialCard({ t }) {
    return (
        <motion.div
            data-testid={`testimonial-card-${t.id}`}
            className="bg-white border border-slate-200 rounded-2xl p-6 flex flex-col h-full"
            whileHover={{
                y: -8,
                scale: 1.02,
                boxShadow: "0 20px 40px -12px rgba(124, 107, 255, 0.35)",
            }}
            whileTap={{ scale: 0.99 }}
            transition={{ duration: 0.25, ease: easeOutStrong }}
            style={{ willChange: "transform" }}
        >
            <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: 5 }).map((_, i) => (
                    <Star
                        key={i}
                        className={`w-4 h-4 ${
                            i < (t.rating || 0)
                                ? "fill-amber-400 text-amber-400"
                                : "text-slate-200"
                        }`}
                    />
                ))}
            </div>
            <p className="text-slate-700 leading-relaxed flex-1">"{t.review_text}"</p>
            <div className="mt-5 flex items-center gap-3 pt-4 border-t border-slate-100">
                {t.image ? (
                    <img
                        src={t.image}
                        alt={t.client_name}
                        className="w-10 h-10 rounded-full object-cover"
                    />
                ) : (
                    <div className="w-10 h-10 rounded-full bg-slate-950 text-white grid place-items-center font-display font-bold">
                        {(t.client_name || "?").charAt(0)}
                    </div>
                )}
                <div className="leading-tight">
                    <div className="font-semibold text-slate-950 text-sm">
                        {t.client_name}
                    </div>
                    <div className="text-xs text-slate-500">{t.business_name}</div>
                </div>
            </div>
        </motion.div>
    );
}
